var _rect, _rect2, _g, _g2, _path, _path2, _rect3, _path3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbnailCreateWhatsApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 380,
    viewBox: "0 0 315 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 313.5,
    height: 379,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 313.5,
    height: 379,
    rx: 11.5,
    stroke: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_342_9075)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 24,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#2D87F3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_342_9075)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1371 33.8793C40.1371 33.7263 40.1265 33.5612 40.1159 33.4036C40.1053 33.1068 40.0068 32.8129 39.8221 32.5297C39.3813 31.8571 38.7648 31.5315 37.9893 31.5648C37.5758 31.5891 37.2622 31.7814 37.0547 32.1374C36.8805 32.4358 36.8366 32.7932 36.9335 33.1174C37.0305 33.4385 37.2516 33.6975 37.553 33.846C37.7106 33.9293 37.756 34.002 37.7393 34.1489V34.1534V42.7827C37.7393 42.8054 37.7378 42.8296 37.7363 42.8554C37.7333 42.9114 37.7318 42.9705 37.7393 43.028C37.7469 43.1401 37.7106 43.1962 37.603 43.2416C37.1017 43.4597 36.8654 43.8702 36.9032 44.4609C36.9381 45.0713 37.3955 45.5136 38.0135 45.5364C38.0408 45.5379 38.068 45.5379 38.0953 45.5379C39.2268 45.5379 40.0659 44.5851 40.1189 43.7005C40.1311 43.54 40.1401 43.384 40.1401 43.2219V38.5566C40.1401 38.0386 40.1417 37.5206 40.1432 37.0026C40.1417 35.9801 40.1447 34.9229 40.1371 33.8793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6966 43.2735C34.5042 43.1901 34.4436 43.0826 34.4633 42.8645V34.0747C34.4724 33.9626 34.5118 33.9066 34.6087 33.8687C34.6663 33.846 34.7268 33.8217 34.7753 33.7854C35.2146 33.4961 35.416 32.9508 35.2752 32.4252C35.1222 31.8966 34.7087 31.5739 34.1664 31.5633C34.1528 31.5633 34.1391 31.5633 34.1255 31.5633C33.4818 31.5633 32.9395 31.8239 32.5139 32.3389C32.2155 32.7024 32.0625 33.1477 32.0625 33.6642V38.534C32.0625 39.361 32.0655 40.1865 32.0686 41.009C32.0716 41.83 32.0746 42.6479 32.0746 43.4673C32.0746 44.1762 32.4881 45.0487 33.4136 45.4016C33.656 45.491 33.8832 45.5349 34.0998 45.5349C34.2255 45.5349 34.3467 45.5197 34.4663 45.4894C34.9253 45.3743 35.2615 44.976 35.3206 44.4761C35.3812 43.9702 35.1252 43.4764 34.6966 43.2735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.492 45.1077L47.4421 44.9729L47.3088 44.9866C47.2209 44.9957 46.8271 45.0108 46.4469 45.0245C45.5941 45.0563 45.4896 45.0638 45.4502 45.0775L45.3639 45.1062L45.3654 45.1986C45.3912 46.5255 44.5248 47.3768 43.7735 47.7024C43.4645 47.8357 43.1176 47.9357 42.7162 48.0054C41.7089 48.1644 40.6926 48.1644 39.6974 48.0054C39.2218 47.9266 38.7977 47.7933 38.4372 47.61C37.9404 47.3525 37.5769 46.9496 37.3587 46.4119C37.3103 46.2922 37.2663 46.1635 37.2239 46.0393C37.1739 45.8939 37.1285 45.756 37.0815 45.6561C36.8771 45.1805 36.3772 44.9245 35.894 45.0472C35.3927 45.1714 35.0594 45.6076 35.0821 46.109C35.0943 46.3998 35.1488 46.6709 35.2715 47.0481C35.3987 47.4267 35.6017 47.8054 35.8546 48.1417C36.3136 48.7642 36.924 49.2414 37.7177 49.5973C38.4811 49.9442 39.3233 50.1486 40.2912 50.2198C40.6426 50.2441 40.9728 50.2562 41.2879 50.2562C41.9589 50.2562 42.5572 50.2017 43.1267 50.0896C43.9704 49.9305 44.6732 49.6791 45.276 49.3231C46.453 48.6234 47.5648 47.7024 47.492 45.1077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4338 35.6469C43.7437 35.6469 41.5549 37.8659 41.5549 40.5939C41.5549 43.3219 43.7437 45.5409 46.4338 45.5409C49.1239 45.5409 51.3126 43.3219 51.3126 40.5939C51.3126 37.8659 49.1239 35.6469 46.4338 35.6469ZM49.0769 40.5939C49.0769 42.0722 47.8909 43.2764 46.4338 43.2764C44.9766 43.2764 43.7906 42.0738 43.7906 40.5939C43.7906 39.1156 44.9766 37.9113 46.4338 37.9113C47.8909 37.9113 49.0769 39.114 49.0769 40.5939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5264 40.7952C47.6004 40.1941 47.1731 39.6468 46.572 39.5728C45.9709 39.4988 45.4236 39.9261 45.3496 40.5272C45.2756 41.1283 45.7029 41.6756 46.304 41.7496C46.9051 41.8236 47.4524 41.3963 47.5264 40.7952Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 44V24H56.815C70.2008 24 75.5157 37.3333 76.5 44Z",
    fill: "#F7F9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 24H275C283.837 24 291 31.1634 291 40V273C291 281.837 283.837 289 275 289H92.5C83.6634 289 76.5 281.837 76.5 273V24Z",
    fill: "#F7F9FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 91.5,
    y: 39,
    width: 184.5,
    height: 119,
    rx: 8,
    fill: "#E4E8EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.05 92V106C193.05 107.1 192.146 108 191.04 108H176.963C175.857 108 174.952 107.1 174.952 106V92C174.952 90.9 175.857 90 176.963 90H191.04C192.146 90 193.05 90.9 193.05 92ZM182.996 103.51L180.885 100.98C180.673 100.73 180.291 100.74 180.1 101L177.597 104.2C177.335 104.53 177.567 105.01 177.989 105.01H190.044C190.456 105.01 190.698 104.54 190.446 104.21L186.917 99.53C186.716 99.26 186.314 99.26 186.113 99.52L182.996 103.51Z",
    fill: "#D2D6DC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 91.5,
    y: 174,
    width: 184.5,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 91.5,
    y: 202,
    width: 184.5,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 91.5,
    y: 230,
    width: 122,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 91.5,
    y: 258,
    width: 77,
    height: 16,
    rx: 8,
    fill: "#E4E8EC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 76.5,
    y: 305,
    width: 214.5,
    height: 32,
    rx: 8,
    fill: "#F7F9FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342_9075"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 24,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_342_9075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.25,
    height: 19.25,
    fill: "white",
    transform: "translate(32.0625 31.5625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailCreateWhatsApp);
export default __webpack_public_path__ + "static/media/ThumbnailCreateWhatsApp.9adf67331ca5509b6860c9c50aca66f9.svg";
export { ForwardRef as ReactComponent };